import programApi from '@src/features/programs/services/program-api';
import type { ChipValueRendererProps } from './chip-member-value';

export const ChipProgramValue = ({ id }: ChipValueRendererProps) => {
  const { data: program } = programApi.useFetchOne({ id });

  return <>{program?.name}</>;
};
